.LoginModal {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  overflow-y: scroll;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
